<template>
  <div class="top-up">
    <TopUpWay />
    <LoadContent />
  </div>
</template>

<script>
// 充值页面进入首页
import TopUpWay from './components/TopUpWay'
import LoadContent from './components/LoadContent'
export default {
  name: 'TopUp',
  components: {
    TopUpWay,
    LoadContent
  }
}
</script>

<style lang="scss" scoped>
.top-up {
  height: 100%;
  padding: 0 40px;
}
</style>
